import { format, parseISO, isValid } from 'date-fns';

const parseDate = (date = '') => {
  const parsedDate = parseISO(date);
  return isValid(parsedDate) ? parsedDate : new Date(date);
};

const formatDate = (date, formatString) => {
  if (!date) return '';
  const d = parseDate(date);
  return format(d, formatString);
};

const dateFormat = (date) => formatDate(date, 'MM/dd/yyyy');

const dateFieldFormat = (date) => formatDate(date, 'yyyy-MM-dd');

export { dateFormat, dateFieldFormat };
